// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"baf14478","280":"caa8643a","588":"2b8c43b2","617":"b742265c","683":"eca12ddb","780":"81cf190d","787":"bed44058","809":"94a9b29b"}[chunkId] + ".chunk.js";
};